import { AbbreviationForm } from "./AbbreviationForm";
import { EnforcementCandidateForm } from "./EnforcementCandidateForm";
import { EvalFailureView } from "./EvalFailureView";
import { GlossaryTermForm } from "./GlossaryTermForm";
import type { RecordTabFormProps } from "./shared";
import { TermAliasForm } from "./TermAliasForm";

/** Универсальный switch по item.item_type — выбирает type-specific
 *  форму. Используется и в Focus (RecordTab), и в Batch (inline edit). */
export function RecordFormSwitch(props: RecordTabFormProps) {
  switch (props.item.item_type) {
    case "glossary_term":
      return <GlossaryTermForm {...props} />;
    case "abbreviation":
      return <AbbreviationForm {...props} />;
    case "term_alias":
    case "alias_candidate":
      return <TermAliasForm {...props} />;
    case "enforcement_candidate":
      return <EnforcementCandidateForm {...props} />;
    case "eval_failure":
      return <EvalFailureView {...props} />;
    default:
      return (
        <section className="rf-section">
          <div className="rf-section__head">
            <span>Неизвестный тип записи: {props.item.item_type ?? "—"}</span>
          </div>
          <div className="rf-section__body">
            <div className="mt-text-tight mt-muted">
              Type-specific форма ещё не реализована — см. секцию «Все поля»
              ниже для отладки.
            </div>
          </div>
        </section>
      );
  }
}
